"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PropertyFieldTypes = require("customer-data-objects/property/PropertyFieldTypes");

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _PropertyTypes = require("customer-data-objects/property/PropertyTypes");

var _default = (0, _PropertyRecord.default)({
  displayOrder: -1,
  externalOptions: true,
  favoritedOrder: -1,
  fieldType: _PropertyFieldTypes.RADIO,
  formField: true,
  groupName: 'contactinformation',
  hidden: false,
  hubspotDefined: true,
  label: 'Form submission',
  name: 'formSubmissions.formId',
  readOnlyDefinition: true,
  readOnlyValue: true,
  type: _PropertyTypes.ENUMERATION
});

exports.default = _default;
module.exports = exports.default;